import React, { Component, Fragment } from 'react'
import axios from 'axios'
import { FormGroup, ControlLabel, FormControl, Button, Form,  } from 'react-bootstrap'
import { Formik, Field, ErrorMessage } from 'formik';
import * as yup from 'yup'
import moment from 'moment'
import { end_point } from './helper'
import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import { faCloudUploadAlt, faCheckCircle } from '@fortawesome/free-solid-svg-icons'

class VerifyAge extends Component {
  constructor(props){
    super(props)
    this.state = {
      success : false,
      url : "",
      error: false,
      loading: false,
      disabled: true,
      proofOfAgehint: false
    }
  }

  handleChange = (setFieldValue) => {
    setFieldValue('file', this.uploadInput.files[0])
  }
  
  handleUpload = async (fields) => {
    console.log('handleUpload')
    this.setState({loading: true})
    try {
      const imageFile = fields.file
      console.log("IMAGE FILE", imageFile)
      let setChildName = fields.childName.split(' ').join('_')
      let setClubName = fields.clubName.split(' ').join('_')
      let file = new Blob([imageFile], {type: 'image'})
      console.log("Preparing the upload")
      console.log("File=",file)
      //NEED TO UPLOAD ROUTE TO GET ENDPOINT
      let response = await axios.post(`${end_point("verify")}/verify`,{
          fileName : `${setClubName}_${setChildName}_${moment().format("MM_DD_YYYY")}`,
          fileType : "image"
        })
      if (response.status === 200 ) {
        var returnData = response.data
        this.setState({url: response.data})
        let signedRequest = returnData.url
        if (signedRequest && signedRequest.includes("proof-of-age")) {
        var options = {
          headers: {
            'Content-Type': 'image' //fileType
          }
        }
        console.log("SIGNED REQUEST", signedRequest)
        console.log("FILES", file)
        let sendingImage = await axios.put(signedRequest,file,options)
        console.log("SENDING IMAGE REQ", sendingImage)
          if (sendingImage.status === 200) {
            this.setState({
              success: true,
              successMessage: "Successfully Uploaded "
            })
          }
        }
      }
    } catch (err) {
      alert("There was an error uploading your file")
      console.log("UPLOAD ERROR", err)
    }
  }
  
  render() {
    const SuccessMessage = () => (
      <div style={{padding:"1em"}}>
        <span className="mobile-title" style={{fontSize: "25px"}}>Upload Complete!</span>
        <div style={{paddingTop: ".5em"}}><img src="smiley.png" style={{ height: '30px', width: '30px'}} /></div>
        <br/>
      </div>
    )
    return (
      <div className="dashboard-box" style={{width: "50%", margin: "auto", marginTop: "3em"}}>
      <div className="white-text">
        <center style={{padding: "3em"}}>
          <h1>Proof of Age</h1>
          <Formik
            validationSchema={schema}
            onSubmit={fields => {
              console.log('onSubmit', fields)
              this.handleUpload(fields)
            }}
              
            initialValues={{
              clubName: '',
              childName: '',
              file: ''
            }}
          >
          {({
            handleSubmit,
            setFieldValue,
            values
          }) => (
          <Form onSubmit={handleSubmit}>
            <div className="age-verify-container">
              <FormGroup className="age-verify-group">
                <ControlLabel>Club Name</ControlLabel>
                <Field name="clubName" className="opaque-grey form-control"/>
                <ErrorMessage component="div" name="clubName" className="invalid-feedback"/>
              </FormGroup>
              <FormGroup className="age-verify-group">
                <ControlLabel>Athlete Full Name</ControlLabel>
                <Field name="childName" className="opaque-grey form-control"/>
                <ErrorMessage component="div" name="childName" className="invalid-feedback"/>
              </FormGroup>
            </div>
            {
              values.file === "" ?
              <Fragment>
                <label htmlFor="file" className="upload-icon">
                  <FontAwesomeIcon icon={faCloudUploadAlt} color='white' size="2x" />
                  <span className="upload-lbl">Click here to upload birth certificate, BC ID or Passport</span>
                </label>
                <input onChange={() => this.handleChange(setFieldValue)} name="file" id="file" ref={(ref) => { this.uploadInput = ref}} type="file" className="hidden"/>
                <ErrorMessage component="div" name="file" className="invalid-feedback"/>
                <br/>
              </Fragment>
              :
              <div className="file-attached">
                <FontAwesomeIcon icon={faCheckCircle} color='white' size="2x" />
                <p>File Attached: {values.file.name}</p>
              </div>
            }
            {
              this.state.success ? 
              <SuccessMessage/>
              : 
              this.state.loading ? 
              <div className="enrolment-loader"></div> 
              :
              <Button style={{width: "50%", margin: "1em"}} className="orange-fill" type='submit'>
                Submit
              </Button>
            }
            <br/>
            <h5>Proof of Age is a requirement to play in this league.  If you don't have Proof of Age handy, return to <a href="https://app.hoopstir.com/verify" style={{color: 'white'}} target="_blank" >app.hoopstir.com/verify</a> later to complete the upload</h5>
            </Form>
            )}

          </Formik>
        </center>
        </div>
      </div>
    )
  }
}
export default VerifyAge

const schema = yup.object({
  clubName: yup.string().required('Required Field'),
  childName: yup.string().required('Required Field'),
  file: yup.mixed().required('Please upload a file')
});